<template>
    <button
        class="action-button"
        @click.prevent="open"
    >
        <span class="action-button-icon relative">
            <span
                v-if="selectedCount"
                v-text="selectedCount"
                class="text-xssss text-white bg-brand-2-950 font-semibold rounded-full absolute top-0 right-0 translate-x-1/4 -translate-y-1/2 py-[4px] pb-[2px] px-1.5 leading-none"
            ></span>

            <span v-html="filtersIcon"></span>
        </span>

        <span class="action-button-label">
            Filters
        </span>
    </button>

    <Transition>
        <Teleport to="#modals">
            <Modal
                v-show="active"
                :active="active"
                title="Filters"
                @close="close"
            >
                <slot name="modal" />

                <template #footer>
                    <div class="flex justify-between">
                        <button
                            class="button button-small button-ghost"
                            @click.prevent="clear"
                            :disabled="selectedCount < 1 || loading"
                        >
                            Clear
                        </button>

                        <button
                            class="button button-small button-2"
                            :disabled="loading"
                            @click.prevent="close"
                        >
                            View Results
                        </button>
                    </div>
                </template>
            </Modal>
        </Teleport>
    </Transition>
</template>

<script setup>
    import { ref, onMounted, useTemplateRef, watch } from 'vue';

    import Modal from '@js/src/components/Modal.vue';

    import filtersIcon from '@img/icons/filters.svg?raw';
    import SpinnerIcon from '@img/icons/spinner.svg?raw';

    const emit = defineEmits([
        'selectedCount',
        'clear',
        'close',
    ]);

    const props = defineProps([
        'selectedCount',
        'resultsCount',
        'loading',
    ]);

    const wrapper = useTemplateRef('wrapper');

    const active = ref(false);

    watch(() => props.resultsCount, (value) => {
        if (value === 0) {
            active.value = false;
        }
    });

    function open() {
        active.value = true;
    }

    function close() {
        active.value = false;

        emit('close');
    }

    function clear() {
        close();

        emit('clear');
    }

    onMounted(() => {
        window.addEventListener('click', function (e) {
            if (wrapper.value && !wrapper.value.contains(e.target)) {
                active.value = false;
            }
        });
    });
</script>
